<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Guarantor name:" prop="guarantorName">
            <el-input
              style="width: 300px"
              v-model="form.guarantorName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Amount or %:" prop="amountOr">
            <el-input style="width: 300px" v-model="form.amountOr"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Expiry date:" prop="expiryDate">
            <el-date-picker
              valueFormat="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 300px"
              v-model="form.expiryDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    return {
      formName: 'GPG',
      form: {
        guarantorName: '',
        amountOr: '',
        expiryDate: '',
      },
      commonFormData: {},
      rules: {
        guarantorName: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        amountOr: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        expiryDate: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'guarantorName', newValue.guarantorName)
        this.$set(this.form, 'amountOr', newValue.amountOr)
        this.$set(this.form, 'expiryDate', newValue.expiryDate)
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
